<template>
  <!--  <v-container>-->
  <v-list class="white--text font-weight-bold">
    <v-list-item class="d-flex align-center" v-if="isClinicStaff && currentClinic">
      <v-spacer />
      <VipIcon size="32" :membership="currentClinic.membership" />
    </v-list-item>
    <!-- <v-list-item style="height: 80px" @click="myProfile">
      <v-list-item-action class="d-flex flex-column justify-center align-center flex-gap-sm">
        <v-fade-transition leave-absolute>
          <v-icon id="account-icon" v-if="!collapses">mdi-account-box</v-icon>
        </v-fade-transition>
      </v-list-item-action>
      <v-list-item-content>
        <v-list-item-title> {{ get(profile, 'name') }}</v-list-item-title>
      </v-list-item-content>
    </v-list-item> -->
    <!-- <v-divider class="mb-4 mt-2" /> -->

    <template
      v-for="{
        to,
        badge,
        clickAction,
        key,
        icon,
        title,
        children,
        divider,
        inset,
        enableCalendar,
      } in routes"
    >
      <v-divider v-if="divider" :inset="inset" :key="`divider-${key}`" />
      <v-list-group
        v-else-if="children"
        :key="`group-${key}`"
        :color="anchorColor"
        :value="isGroupActive(children)"
        :active-class="''"
      >
        <template v-slot:activator>
          <v-list-item-action>
            <v-badge v-if="badge" v-bind="badge"></v-badge>
            <v-icon>{{ icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-title>{{ title }}</v-list-item-title>
        </template>
        <v-list-item
          v-for="child in children"
          :key="child.key"
          :to="child.to"
          :exact="true"
          :color="anchorColor"
        >
          <v-list-item-action>
            <v-badge v-if="child.badge" v-bind="child.badge"></v-badge>
            <span class="full-width text-center">{{ child.textIcon }}</span>
            <v-icon>{{ child.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title v-text="child.title" />
          </v-list-item-content>
        </v-list-item>
      </v-list-group>
      <div v-else :key="`item-${key}`">
        <v-list-item
          :to="to"
          @click="dynamicsClickAction(clickAction)"
          :exact="to === '/'"
          :color="anchorColor"
        >
          <v-list-item-action>
            <!-- <v-badge
              v-if="hasUnreadNotification && title === 'Notification'"
              color="red"
              dot
            ></v-badge> -->
            <v-badge v-if="badge" v-bind="badge"></v-badge>
            <v-icon>{{ icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title v-text="title" />
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-if="enableCalendar && collapses && !isAdmin" class="pa-0">
          <v-date-picker
            v-model="selectedDate"
            @input="navigateToRouteWithDate(to, $event)"
            full-width
            no-title
            :color="$vuetify.theme.themes.light.secondary"
            :events="totalCountEvents"
            event-color="red"
          />
        </v-list-item>
      </div>
    </template>
  </v-list>
  <!--  </v-container>-->
</template>

<script>
import { canAccessRoute } from '@/router';
import { getMenuData } from '@/services/menu';
import { mapGetters } from 'vuex';
import { roleOptions } from '@/data/optionsConstants';
import { get } from 'lodash';
import VipIcon from '@/components/VipIcon';
import store from '@/store';

export default {
  name: 'drawerNav',
  components: { VipIcon },
  props: {
    collapses: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      roleOptions,
      selectedDate: null,
    };
  },
  inject: ['ssoLogout'],
  computed: {
    ...mapGetters('auth', ['role', 'profile', 'isAdmin', 'currentClinic', 'isClinicStaff']),
    ...mapGetters('notification', ['pendingAssignmentAppointmentCount', 'unreadCount']),
    ...mapGetters('booking', ['unreadCount']),
    currentRoute() {
      return this.$route.path;
    },

    notificationUnreadCount() {
      return this.$store.getters['notification/unreadCount'];
    },
    bookingUnreadCount() {
      return this.$store.getters['booking/unreadCount'];
    },

    totalCountEvents() {
      return [...this.unreadCountEvents, ...this.expiredCountEvents];
    },
    unreadCountEvents() {
      if (!this.bookingUnreadCount.unread) return [];
      return Object.keys(this.bookingUnreadCount.unread).filter(
        date => this.bookingUnreadCount.unread[date] > 0,
      );
    },
    expiredCountEvents() {
      if (!this.bookingUnreadCount.expired) return [];
      return Object.keys(this.bookingUnreadCount.expired).filter(
        date => this.bookingUnreadCount.expired[date] > 0,
      );
    },

    routes() {
      const menuKeyBadgeMap = {
        // timetableAndAppointment: !!this.pendingAssignmentAppointmentCount && {
        //   dot: true,
        //   color: 'red',
        // },
        // appointments: !!this.pendingAssignmentAppointmentCount && { dot: true, color: 'red' },
        timetable: !!this.bookingUnreadCount.total && { dot: true, color: 'red' },
        notification: this.isClinicStaff &&
          !!this.notificationUnreadCount && { dot: true, color: 'red' },
      };

      const filter = arr =>
        arr
          .map(x => {
            x.badge = menuKeyBadgeMap?.[x?.key];

            if (x.children) {
              x = { ...x, children: filter(x.children) };
              x.children = x.children.filter(
                x => !x.auth || x.auth.includes(store.getters['auth/role']),
              );
              if (x.children.length) return x;
            } else if (x.to != null) {
              return canAccessRoute(x.to) && x;
            } else if (x.clickAction && this[x.clickAction]) {
              return x;
            } else {
              return false;
            }
          })
          .filter(x => x);
      return filter(getMenuData);
    },
    anchorColor() {
      return this.$vuetify.theme.themes.light.role_anchor || '#689F38';
    },
  },
  methods: {
    get,
    dynamicsClickAction(name) {
      if (name) this[name]();
    },
    myProfile() {
      this.$router.push({ name: 'myProfile' }).catch(() => {});
    },
    navigateToRouteWithDate(routePath, date) {
      if (routePath && date) {
        this.$router
          .push({
            path: routePath,
            query: { date },
          })
          .catch(() => {});
      }
    },
    isGroupActive(children) {
      const currentPath = this.$route.path;
      return children.some(child => {
        if (!child.to) return false;
        return currentPath === child.to || currentPath.startsWith(child.to + '/');
      });
    },
  },
};
</script>

<style scoped>
::v-deep .theme--light.v-icon {
  color: var(--v-role_inverse-base);
}
::v-deep .theme--light.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled) {
  color: var(--v-role_inverse-base) !important;
}
::v-deep .theme--light.v-list-item--active::before {
  opacity: 0;
}
::v-deep .theme--light.v-list-item--active {
  background-color: var(--v-primary_inverse-base) !important;
  color: #1565c0 !important;
}
::v-deep .theme--light.v-list-item--active .v-icon {
  color: #1565c0 !important;
}
::v-deep .theme--light.v-list-group .v-list-item--active::before {
  opacity: 0;
}
::v-deep .theme--light.v-list-group .v-list-group__items .v-list-item--active {
  background-color: var(--v-primary_inverse-base) !important;
  color: #1565c0 !important;
}
::v-deep .theme--light.v-list-group .v-list-group__items .v-list-item--active .v-icon {
  color: #1565c0 !important;
}
::v-deep .theme--light.v-list-group__header.v-list-item--active {
  background-color: transparent !important;
  color: var(--v-role_inverse-base) !important;
}
::v-deep .theme--light.v-list-group__header.v-list-item--active .v-icon {
  color: var(--v-role_inverse-base) !important;
}
::v-deep .v-list-group__header {
  background-color: transparent !important;
}
::v-deep .v-list-group__header .v-list-item__title,
::v-deep .v-list-group__header .v-icon {
  color: var(--v-role_inverse-base) !important;
}
::v-deep .v-list-item__title {
  font-size: 1.25rem;
  font-weight: 700;
}
::v-deep .v-list-group .v-list-group__header .v-list-item__icon.v-list-group__header__append-icon {
  margin-left: 0px !important;
  min-width: 30px;
}
::v-deep .calendar-picker {
  box-shadow: none !important;
}
::v-deep .calendar-picker .v-picker__body {
  background-color: transparent !important;
}
</style>
